import React from 'react';
import { getTranslation } from "./i18n";

const Menu = ({ onDifficultySelected, locale }) => {
  return (
    <div className='w-screen h-screen flex flex-col items-center justify-center p-8'>
      <div className="card py-8 bg-base-200 text-center w-full max-w-xl">
      <p className="text-lg">{getTranslation(locale, "welcome")}</p>
			<h1 className="text-4xl font px-4">{getTranslation(locale, "checkers")}</h1>
      <div className="flex flex-col gap-4 px-8">
				<p className="pt-16 text-lg">{getTranslation(locale, "chooseOption")}</p>
        <button className="btn btn-success btn-lg w-full" onClick={() => onDifficultySelected(2)}>{getTranslation(locale, "easy")}</button>
        <button className="btn btn-warning btn-lg w-full" onClick={() => onDifficultySelected(3)}>{getTranslation(locale, "medium")}</button>
        <button className="btn btn-error btn-lg w-full" onClick={() => onDifficultySelected(4)}>{getTranslation(locale, "hard")}</button>
      </div>
    </div>
    </div>
  );
};

export default Menu;



// WEBPACK FOOTER //
// ./src/Menu.js